import { useState } from "react"
import classNames from "classnames"

import { ValueView } from "web/components"
import Label from "web/components/Form/Controls/Label"

export default function ValueWithLabel({
  fieldKey,
  kind = "",
  label,
  description,
  required = false,
  value,
  onClick,
  showLinkIcon = false,
  hideLabel = false,
  valueLocked = false,
  currentUserDataAdmin,
  inEditMode,
  readOnly,
}) {
  const hasClickHandler = typeof onClick === "function"

  const [hoveringOverValueView, sethoveringOverValueView] = useState(false)

  const valueWithLabelWrapperClasses = classNames(
    "value-with-label",
    kind.toLowerCase(),
    {
      "flex items-start gap-4": !hideLabel,
      editableOrLocked: hasClickHandler || (valueLocked && !readOnly),
      inEditMode: inEditMode,
    }
  )

  const valueViewWrapperClasses = classNames(
    "group/value min-w-0 text-neutral-2",
    !hideLabel && "flex max-w-full text-right",
    !hideLabel && inEditMode && "basis-1/2",
    !readOnly && {
      "!pr-2.5": valueLocked,
      "hover:!bg-slate-100": valueLocked && !currentUserDataAdmin,
      "!bg-slate-100": valueLocked && inEditMode && !currentUserDataAdmin,
    }
  )

  const handleMouseEnter = () => sethoveringOverValueView(true)
  const handleMouseLeave = () => sethoveringOverValueView(false)

  return (
    <div className={valueWithLabelWrapperClasses}>
      {!hideLabel && (
        <Label
          kind={kind}
          label={label}
          description={description}
          required={required}
          variant="inline"
        />
      )}
      <div
        data-testid={`view-or-edit-value-${label}`}
        onClick={hasClickHandler ? onClick : () => {}}
        onMouseEnter={valueLocked ? handleMouseEnter : () => {}}
        onMouseLeave={valueLocked ? handleMouseLeave : () => {}}
        className={valueViewWrapperClasses}
      >
        <ValueView
          fieldKey={fieldKey}
          readOnly={valueLocked && !currentUserDataAdmin}
          showLock={valueLocked && (hoveringOverValueView || inEditMode)}
          {...value}
          placeholder={<span className="text-sm text-neutral-8">No Value</span>}
          preventClickHandler={!readOnly && valueLocked && currentUserDataAdmin}
          showLinkIcon={showLinkIcon}
        />
      </div>
    </div>
  )
}
